/* ============================================================
   THE CALCULATED CHEMIST · ARCHIVAL INTERACTIONS
   One behaviour only: the documentation panel, which is a
   tablist on wide viewports and an accordion on narrow ones.

   The two patterns never nest. The ARIA roles are rewritten on
   mode change so a screen reader is told the truth about the
   pattern currently on screen.

   Progressive enhancement: with JS off, every panel is visible
   and readable. Nothing here is required to read the content.
   ============================================================ */

(function () {
  'use strict';

  var NARROW = '(max-width: 749px)';

  function setup(root) {
    var tablist = root.querySelector('.tcc-docpanel__tabrow');
    var tabs = tablist ? Array.prototype.slice.call(tablist.querySelectorAll('.tcc-tab')) : [];
    var panels = Array.prototype.slice.call(root.querySelectorAll('.tcc-docpanel__panel'));
    var accs = Array.prototype.slice.call(root.querySelectorAll('.tcc-docpanel__acc'));

    if (!panels.length) return;

    var selected = 0;
    var mq = window.matchMedia(NARROW);
    var open = panels.map(function (_, i) { return i === 0; });

    function applyWide() {
      if (tablist) tablist.setAttribute('role', 'tablist');

      tabs.forEach(function (tab, i) {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-selected', i === selected ? 'true' : 'false');
        tab.setAttribute('tabindex', i === selected ? '0' : '-1');
        tab.setAttribute('aria-controls', panels[i].id);
      });

      panels.forEach(function (panel, i) {
        panel.setAttribute('role', 'tabpanel');
        if (tabs[i]) panel.setAttribute('aria-labelledby', tabs[i].id);
        panel.setAttribute('tabindex', '0');
        if (i === selected) panel.removeAttribute('hidden');
        else panel.setAttribute('hidden', '');
      });

      accs.forEach(function (acc) { acc.setAttribute('aria-expanded', 'false'); });
    }

    function applyNarrow() {
      if (tablist) tablist.removeAttribute('role');
      tabs.forEach(function (tab) {
        tab.removeAttribute('role');
        tab.removeAttribute('aria-selected');
        tab.removeAttribute('tabindex');
      });

      accs.forEach(function (acc, i) {
        acc.setAttribute('aria-expanded', open[i] ? 'true' : 'false');
        acc.setAttribute('aria-controls', panels[i].id);
      });

      panels.forEach(function (panel, i) {
        panel.setAttribute('role', 'region');
        if (accs[i]) panel.setAttribute('aria-labelledby', accs[i].id);
        panel.removeAttribute('tabindex');
        if (open[i]) panel.removeAttribute('hidden');
        else panel.setAttribute('hidden', '');
      });
    }

    function apply() {
      if (mq.matches) applyNarrow();
      else applyWide();
    }

    function select(i) {
      selected = i;
      open[i] = true;
      applyWide();
      tabs[i].focus();
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        if (mq.matches) return;
        select(i);
      });

      tab.addEventListener('keydown', function (e) {
        if (mq.matches) return;
        var next = null;
        if (e.key === 'ArrowRight') next = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = tabs.length - 1;
        if (next === null) return;
        e.preventDefault();
        select(next);
      });
    });

    accs.forEach(function (acc, i) {
      acc.addEventListener('click', function () {
        if (!mq.matches) return;
        open[i] = !open[i];
        selected = i;
        applyNarrow();
      });
    });

    if (mq.addEventListener) mq.addEventListener('change', apply);
    else if (mq.addListener) mq.addListener(apply);

    apply();
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('.tcc-docpanel'), setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
